import React from "react";

interface ErrorBoundaryState {
  hasError: boolean;
}

const RELOAD_DELAY_MS = 60000;

// A kiosk's best recovery from a render crash is reload-from-cache
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };
  private reloadTimer: number | null = null;

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Unhandled render error:", error, info);
    if (!this.reloadTimer) {
      this.reloadTimer = window.setTimeout(
        () => window.location.reload(),
        RELOAD_DELAY_MS,
      );
    }
  }

  componentWillUnmount() {
    if (this.reloadTimer) clearTimeout(this.reloadTimer);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            position: "fixed",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "#0d1b2a",
            color: "#ffffff",
            fontFamily: "sans-serif",
            textAlign: "center",
            gap: "1rem",
          }}
        >
          <img src="/logo192.png" alt="" width={96} height={96} />
          <div style={{ fontSize: "1.5rem" }}>Restarting display…</div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
